// Parse backend createdAt values which may come as:
// - epoch seconds with fractional part (e.g., 1755824357.180283)
// - epoch milliseconds (number)
// - ISO string
// Returns milliseconds since epoch (number)
export const parseCreatedAtMs = (value) => {
    if (value == null) return 0;
    if (typeof value === 'number') {
        return value < 1e12 ? Math.round(value * 1000) : Math.round(value);
    }
    if (typeof value === 'string') {
        // pure numeric string (possibly with dot)
        if (/^\d+(?:\.\d+)?$/.test(value)) {
            const n = parseFloat(value);
            if (!Number.isNaN(n)) {
                return n < 1e12 ? Math.round(n * 1000) : Math.round(n);
            }
        }
        const d = new Date(value);
        const ms = d.getTime();
        return Number.isNaN(ms) ? 0 : ms;
    }
    const d = new Date(value);
    const ms = d.getTime();
    return Number.isNaN(ms) ? 0 : ms;
};


